import { dispatch } from '../dispatcher';
import { ActionTypes, AlertTypes } from '../constants/MogamboConstants';

export function receiveAllBots(domainData, domainMetadata, callback) {
  dispatch(ActionTypes.RECEIVE_ALL_BOTS, {
    domainData,
    domainMetadata,
    callback,
  });
}

export function receiveNewBot(data) {
  dispatch('RECEIVE_NEW_BOT', {
    data: data.domain,
  });

  dispatch('STOP_LOADING', {
    message: 'New Bot received',
  });
}

export function receiveMetaInfo(data, cb) {
  dispatch('RECEIVE_META_INFO', {
    data,
    callback: cb,
  });
}

export function receiveNewStory(data) {
  dispatch('RECEIVE_NEW_STORY', {
    data: data.story,
  });
}

export function receiveAllSubStories(data) {
  dispatch('RECEIVE_ALL_SUB_STORIES', {
    data,
  });
}

export function receiveSubstoryGraph({ graph, sub_story, callback }) {
  dispatch('RECEIVE_SUBSTORY_GRAPH', {
    graph,
    sub_story,
    callback,
  });

  // Dispatch not needed. Might be the potential cause for dispatch in dispatch error

  // dispatch('STOP_LOADING', {
  //   message: 'Story graph received',
  // });
}

export function receiveNewStep(data, callback) {
  dispatch('STEP_CREATED', {
    data,
    callback,
  });
}

export function receiveStepPriorities(data) {
  dispatch('RECEIVE_STEP_PRIORITIES', {
    data,
  });
}

export function receiveUserResponses(json, callback) {
  dispatch(ActionTypes.RECEIVE_USER_RESPONSES, {
    meta: json.meta,
    data: json.body,
    callback,
  });
}

export function receiveDisambiguationTexts(data, callback) {
  dispatch(ActionTypes.RECEIVE_DISAMBIGUATION_TEXTS, {
    data,
    callback,
  });
}

export function partnerResponseReceived(json, callback) {
  dispatch(ActionTypes.PARTNER_RESPONSE_RECEIVED, {
    meta: json.meta,
    data: json.body,
    callback,
  });
}

export function receiveTruthTableResponse(data) {
  dispatch('RECEIVE_TRUTH_TABLE_RESPONSE', {
    data,
  });
}

export function receiveGeneralResponses(data) {
  dispatch('RECEIVE_GENERAL_RESPONSES', {
    data,
  });
}

export function receiveBotExtract(domain, data) {
  dispatch('RECEIVE_BOT_EXTRACT', {
    data,
    domain,
  });
}

export function receiveTransferBot(data) {
  dispatch('RECEIVE_TRANSFER_BOT', {
    data,
  });
}

export function receiveDeployBot(data, action = '') {
  // If action is not there, which means bot training has been started.
  if (!action)
    dispatch(ActionTypes.RECEIVE_DEPLOY_BOT, {
      data,
    });

  dispatch(ActionTypes.CREATE_ALERT, {
    status: true,
    message:
      action === 'webguide'
        ? 'AI Site Sync training has started. You will receive an email when the process has completed.'
        : 'The bot is being deployed. You will receive an email when the process has completed.',
    alertLength: 3000,
  });
}

/*
 * Actions for recieving POST data Api responses
 */

export function receiveStepPrioritiesPOST() {
  window.location.reload();
}

export function receiveGeneralResponsesPOST() {
  window.location.reload();
}

export function receiveUpdateBotPOST() {
  window.location.reload();
}

export function showRequestFailureAlert(msg) {
  dispatch('STOP_LOADING', {
    message: msg,
  });

  dispatch(ActionTypes.CREATE_ALERT, {
    status: true,
    message: msg,
    alertLength: 1500,
    messageType: AlertTypes.NEGATIVE,
  });
}

export function showRequestSuccessAlert(msg) {
  dispatch('STOP_LOADING', {
    message: msg,
  });

  dispatch(ActionTypes.CREATE_ALERT, {
    status: true,
    message: msg,
    alertLength: 1500,
    messageType: AlertTypes.POSITIVE,
  });
}

export function receivedGeneralNodes(data) {
  dispatch(ActionTypes.SET_GENERAL_NODES, {
    data,
  });
}

export function updatedGeneralNodes(success, failure) {
  dispatch(ActionTypes.UPDATE_GENERAL_NODES, {
    success,
    failure,
  });
}

export function receivedNodeSummary(data) {
  dispatch(ActionTypes.SET_NODE_SUMMARY, {
    data,
  });
}

export function receiveSynonyms(data) {
  dispatch(ActionTypes.SET_SYNONYMS, { data });
}

export function receiveMeanings(data, callback) {
  dispatch(ActionTypes.SET_MEANINGS, { data, callback });
}

export function updatedMeanings() {
  dispatch(ActionTypes.UPDATED_MEANINGS);
}

export function updateUserSaysEntities() {
  dispatch(ActionTypes.UPDATED_USER_SAYS_ENTITIES);
}

export function receiveBotResponses(data, meta, callback, languageCode) {
  dispatch(ActionTypes.SET_BOT_RESPONSES, {
    data,
    meta,
    callback,
    languageCode,
  });
}

export function onBotResponsesSaved(data, callback) {
  dispatch(ActionTypes.BOT_RESPONSES_RECEIVED, {
    data,
  });
  if (callback) callback();
}

export function receiveBusinessList(businessList, meta) {
  dispatch(ActionTypes.RECEIVED_BUSINESS_LIST, {
    businessList,
    meta,
  });
}

export function updateGraph(event) {
  dispatch(ActionTypes.FORCE_UPDATE_GRAPH, { ...event });
}
